import styled from 'styled-components';

export const Wrapper = styled.div`
  & button {
    @media (width >= 29rem) {
      width: auto;
    }
  }

  & form {
    flex-direction: column;

    & > div {
      flex: 1;
    }

    & input {
      width: auto;
    }

    & button {
      margin-block-start: 0;
    }

    @media (width >= 57rem) {
      max-width: 422px;
      flex-direction: row;

      & input {
        width: 280px;
      }

      & button {
        margin-block-start: 24px;
      }

      & > div {
        flex: 1 0 280px;
      }
    }
  }
`;
